import React from "react";
import './Contact_footer.css';
const Contact_footer = () => {
  return (
    <div className="contact-footer-ap row">
      <div className="contact-footer-wrap col-xl-12">

        {/* HERO */}
        <section className="contact-footer-hero">
          <h1>Contact Us </h1>
          <p>We’re here when you need us. Thoughtful support, just like everything we do.</p>
          <p>At Garshya, every interaction matters. Whether you have a question, need assistance, or want to collaborate, our team is ready to help you with clarity and care.</p>
        </section>

        {/* SECTIONS */}
        <section className="contact-footer-section">

          <h2> Get in Touch</h2>
          <ul>
            <li>Email: <a href="mailto:support@garshya.com" className="contact-footer-email">support@garshya.com</a></li>
            <li>Working Hours: Monday to Saturday, 10:00 AM – 7:00 PM (IST)</li>
          </ul>
          <p>We aim to respond to all queries within 24–48 business hours.</p>

          <h2> Customer Support</h2>
          <p>Need help with an order, product, or service? Reach out to our support team and we’ll ensure your concern is addressed promptly and transparently.</p>

          <h2> Business & Partnerships</h2>
          <p>For collaborations, seller onboarding, or business inquiries: <a href="mailto:business@garshya.com" className="contact-footer-email">business@garshya.com</a></p>
          <p>We work with partners who align with our quality-first philosophy.</p>

          <h2> Registered Address</h2>
          <p>Garshya<br />
          Mumbai | Maharashtra | India<br />
          (As per applicable Indian regulations, we ensure our business details are transparent and accessible.)</p>

          <h2>Send Us a Message</h2>
          <p>Have something specific to share? Fill out our contact form on the website and our team will get back to you.</p>
          <p>At Garshya, support isn’t just a function. It’s part of the experience.</p>

        </section>

      </div>
    </div>
  );
};

export default Contact_footer;